import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { blobDownload } from "@utils/utilities";

const initialState = {
  loading: false,
  error: false,
  success: false,
};

export const downloadUseCasesSlice = createSlice({
  name: "downloadUseCases",
  initialState,
  reducers: {
    downloadUseCasesStart: (state) => ({
      ...state,
      loading: true,
      error: false,
      success: false,
    }),
    downloadUseCasesSuccess: (state) => ({
      ...state,
      loading: false,
      error: false,
      success: true,
    }),
    downloadUseCasesFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    resetDownloadUseCases: () => ({
      ...initialState,
    })
  },
});

const { actions, reducer } = downloadUseCasesSlice;

export const { 
  downloadUseCasesStart,
  downloadUseCasesSuccess,
  downloadUseCasesFailure,
  resetDownloadUseCases,
} = actions;

export const downloadUseCasesTemplate = (scorecardId) => (dispatch) => {
  dispatch(downloadUseCasesStart());
  apiService
    .get(
      `${Constants.API.SCORE_CARD}/${scorecardId}/${Constants.API.IMPORT_USE_CASES.DONWLOAD}`,
      { responseType: "blob" }
    )
    .then((response) => {
      dispatch(downloadUseCasesSuccess());
      const contentDisposition = response.headers["content-disposition"];
      const parts = contentDisposition.split("filename=");
      const filename = parts[1] ? parts[1].trim() : null;
      blobDownload(
        response.data,
        filename || Constants.IMPORT_USE_CASES.IMPORT_STEP.DOWNLOAD_TEMPLATE.FILE_NAME
      );
    })
    .catch(() => {
      dispatch(downloadUseCasesFailure());
  });
}

export default reducer;
